import React from "react";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";

function InitialLoading() {
    const isMobile = useMediaQuery("(max-width:600px)");
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
                backgroundColor: "#000",
                //   backgroundImage: "url('../../assets/images/homepage-background.svg')",
            }}
            position="fixed"
        >
            {/* <CircularProgress  /> */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: {
                        xs: "68vh",
                        sm: "68vh",
                        md: "70vh",
                        lg: "78vh",
                    },
                    width: "100%",
                    overflow: "hidden",
                }}
            // position="fixed"
            >
                {isMobile ? (
                    <img
                        src={"../../../assets/images/loading-mobile.gif"}
                        alt="loading..."
                        loading="lazy"
                    />
                ) : (
                    <img
                        src={"../../../assets/images/loader3.gif"}
                        alt="loading..."
                        loading="lazy"
                    />
                )}
            </Box>

        </Box>
    );
}

export default InitialLoading;
